import { c as _c } from "react/compiler-runtime";
import style from "./Infobox.module.scss";
import React from "react";
export const InfoBox: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className={style.infoBox} data-cy="info-box">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};